const LoadCondition = () =>
  import(
    /* webpackChunkName: "base-info-load-condition" */ '@/pages/base-info/order-properties/load-condition/index.vue'
  )
const CreateLoadCondition = () =>
  import(
    /* webpackChunkName: "base-info-load-condition" */ '@/pages/base-info/order-properties/load-condition/create.vue'
  )
const EditLoadCondition = () =>
  import(
    /* webpackChunkName: "base-info-load-condition" */ '@/pages/base-info/order-properties/load-condition/edit.vue'
  )

export default {
  path: 'load-condition',
  meta: {
    label: 'loadCondition',
    auth: 'loadCondition'
  },
  component: {
    name: 'LoadCondition',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoPropertyLoadCondition',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: LoadCondition
    },
    {
      name: 'BaseInfoCreatePropertyLoadCondition',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLoadCondition
    },
    {
      name: 'BaseInfoEditPropertyLoadCondition',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLoadCondition,
      props: true
    }
  ]
}
